<div class="component-viewer">
    <mat-card class="mat-elevation-z8">
        <gt-table *ngIf="true" [loading]="isLoading" [defaultPageSize]="10" [updateFilterEvent]="updateFilterEvent"
            [filter]="filter" [data]="outings" (filterChanged)="getAllOutingsByUserId()" (filterReset)="resetFilter()">
        </gt-table>
        <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
        <table mat-table [dataSource]="outings" multiTemplateDataRows>
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Outing Name </th>
                <td mat-cell *matCellDef="let outing"><a
                        routerLink="/outing-management/administration/outing/details/{{outing.id}}">{{outing.name}}</a></td>
            </ng-container>
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let outing">
                    <button mat-stroked-button (click)="editOuting(outing)">
                        Edit <mat-icon>edit</mat-icon>
                    </button>&nbsp;
                    <button mat-stroked-button color="warn" (click)="deleteOuting(outing)">
                        Delete <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let outing; columns: displayedColumns;"></tr>
        </table>
    </mat-card>
</div>